import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import { FormControl } from "@material-ui/core";
import { Dropdown } from "primereact/dropdown";
import { CSVLink } from "react-csv";
import IssueNumberService from "../services/IssueNumberService";
import StockSummaryService from "../services/StockSummaryService";
import { useBrand } from "./../helper/BrandContext";

const BatchTracking = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  var issueNumberService = new IssueNumberService();
  var stockSummaryService = new StockSummaryService();
  var date = new Date();
  date.setDate(date.getDate() - 7);
  const [tableRequest, setTableRequest] = useState({
    ProductId: 0,
    BatchNo: "",
    BrandId: 0
  });

  const [state, setState] = useState({
    first: 0,
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: date,
    ToDate: new Date(),
    sortOrder: "",
    headers: [
      { label: "Scan Location", key: "location" },
      { label: "Scan Count", key: "count" }
    ]
  });
  const [products, setProducts] = useState([]);

  const navigate = useNavigate();

  function GetBatchTracking() {
    if (tableRequest.ProductId == undefined || tableRequest.ProductId == 0) {
      toast.error("Please Select Product");
      return;
    } else if (
      tableRequest.BatchNo == undefined ||
      tableRequest.BatchNo == ""
    ) {
      toast.error("Please Enter Batch No");
      return;
    } else {
      setState((prevData) => ({
        ...prevData,
        loading: true
      }));
      stockSummaryService
        .GetBatchTracking(tableRequest)
        .then((response) => {
          response = response;
          if (response && response.responseCode == "200") {
            setState((prevData) => ({
              ...prevData,
              datasource: [...response.responseData],
              loading: false
            }));
          } else {
            setState((prevData) => ({
              ...prevData,
              datasource: [],
              loading: false
            }));
          }
        })
        .catch((error) => {
          console.error("API request failed:", error);
          toast.error("Failed to fetch data");
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
        });
    }
  }

  function GetProducts(brandId) {
    issueNumberService.getproducts(brandId).then((response) => {
      if (response && response.responseCode == "200") {
        const data = response.responseData;
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
        setProducts(data);
      } else {
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
        setProducts([]);
      }
    });
  }

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.BrandId = brand;
      const storedToken = sessionStorage.getItem("token");
      if (storedToken) {
        isLoggedIn(true);
      } else {
        isLoggedIn(false);
        navigate("/login");
      }
      GetProducts(brand);
    }
  }, [isLoggedIn, navigate, brand]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setTableRequest((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="row">
        <div className="flex items-center md:mb-0">
          <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
            Batch Tracking
          </h1>
        </div>
      </div>
      <div className="row">
        <div className=" filter-container flex items-center w-full justify-between">
          <FormControl className="flex-1 mx-2" margin="dense">
            <Dropdown
              onChange={handleFormChange}
              filter
              name="ProductId"
              options={products}
              value={tableRequest.ProductId}
              optionLabel="label"
              optionValue="id"
              placeholder="Select Product"
              className="w-full md:w-14rem"
            />
          </FormControl>
          <FormControl className="flex-1 mx-2" margin="dense">
            <InputText
              type="search"
              name="BatchNo"
              onInput={handleFormChange}
              value={tableRequest.BatchNo || ""}
              placeholder="Batch Number"
              size="22"
              className="p-inputtext-sm"
            />
          </FormControl>
          <button
            type="button"
            style={{
              width: "98.11px",
              height: "40px",
              fontSize: "16px"
            }}
            onClick={GetBatchTracking}
            className="ml-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Submit
          </button>
          <CSVLink
            type="button"
            data={state.datasource}
            headers={state.headers}
            filename={"Batch Tracking.csv"}
            className="ml-3 bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Export
          </CSVLink>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {state.loading ? (
        <Loader />
      ) : (
        <>
          <div className="datatable-responsive-demo">
            <DataTable
              value={state.datasource}
              header={header}
              emptyMessage={state.emptyMessage}
              loading={state.loading}
              responsiveLayout="scroll"
            >
              <Column field="location" header="Scan Location" />
              <Column field="count" header="Scan Count" />
            </DataTable>
          </div>
        </>
      )}
    </>
  );
};

export default BatchTracking;
